import variantColor from './colors';

class SelectMenu {
  constructor(selectSelector) {
    this.container = document.querySelector('body');
    this.selectSelector = selectSelector;
    this.init();
  }

  init() {
    variantColor();

    document.querySelectorAll('bundle-product').forEach((container) => {
      const list = container.querySelector(
        `${this.selectSelector} .select-list`,
      );
      const field = container.querySelector(
        `${this.selectSelector} .select-field`,
      );
      const firstItem = list?.querySelector('li');

      if (firstItem) {
        const variantId = firstItem.getAttribute('data-variant-id');
        field.setAttribute('data-selected-variant', variantId);
        field.innerHTML = firstItem.innerHTML;
      }

      container.addEventListener('click', (e) => {
        const targetSelect = e.target.closest(this.selectSelector);
        if (targetSelect) {
          this.handleSelectClick(targetSelect, container);
        } else {
          this.closeAllSelects(container);
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (
        !e.target.closest(this.selectSelector) &&
        !e.target.closest('.select-list')
      ) {
        this.closeAllSelects();
      }
    });
  }

  handleSelectClick(select) {
    const parent = select.querySelector('[data-parent-select]');
    const field = select.querySelector('.select-field');
    const list = select.querySelector('.select-list');

    this.closeOtherSelects(field);

    list.classList.toggle('open');
    parent.classList.toggle('turn');

    list.addEventListener('click', (e) => e.stopPropagation());

    const selectItemClickHandler = (e) => {
      const selectedItem = e.target.closest('li');
      if (selectedItem) {
        const variantId = selectedItem.getAttribute('data-variant-id');
        field.setAttribute('data-selected-variant', variantId);
        field.innerHTML = selectedItem.innerHTML;
        list.classList.remove('open');
        parent.classList.remove('turn');
        list.removeEventListener('click', selectItemClickHandler);
      }
    };

    list.addEventListener('click', selectItemClickHandler);
  }

  closeOtherSelects(clickedField) {
    const selects = [...this.container.querySelectorAll(this.selectSelector)];
    selects.forEach((select) => {
      const field = select.querySelector('.select-field');
      const parent = select.closest('[data-parent-select]');
      const list = select.querySelector('.select-list');

      if (field !== clickedField && list.classList.contains('open')) {
        list.classList.remove('open');
        parent.classList.remove('turn');
      }
    });
  }

  closeAllSelects() {
    const selects = [...this.container.querySelectorAll(this.selectSelector)];
    selects.forEach((select) => {
      const parent = select.closest('[data-parent-select]');

      const list = select.querySelector('.select-list');

      list.classList.remove('open');
      parent?.classList.remove('turn');
    });
  }
}

// eslint-disable-next-line no-unused-vars
const selectMenu = new SelectMenu('.select-menu');
